export default __webpack_public_path__ + "src/images/packages/lachataigne-farm/402765559c5e42d670287f9868a28189-5.png";